import React, { useRef, useState } from 'react'
import { Header } from '../../header'
import { Footer } from '../../components/footer/footer'
import { Channel, withLayout } from '@at/sauron-platform-core'
import { GlobalStyle, StyledSearchResults } from '../search-results/search-results.styles'
import {
    StyledAiSearchMain,
    StyledAiSearchQueryContainer,
    StyledIconIntelligenceSpin,
    StyledQueryInput,
    StyledSearchResultsIFrame,
} from './ai-search.styles'
import { Button, Spinner } from '@at/design-system-elements'
import { useFederatedQuery } from '@at/sauron-platform-graphql'
import { AiSearchResultsQuery } from '../../contexts/search-results-context/query/ai-search.fed.query'
import { AiSearchQuery_Query } from '../../contexts/search-results-context/query/__generated__/ai-search.fed.query'

const AiSearchPage = () => {
    const [searchQuery, setSearchQuery] = useState<string>('')
    const inputRef = useRef<HTMLInputElement>(null)
    const doSearch = () => {
        setSearchQuery(inputRef?.current?.value || '')
    }
    const { data, loading, error } = useFederatedQuery<AiSearchQuery_Query>(AiSearchResultsQuery, {
        variables: { query: searchQuery, channel: Channel.cars },
        skip: searchQuery.length === 0,
    })

    const results = () => {
        if (data?.aiSearch) {
            if (data.aiSearch.success) {
                return (
                    <>
                        <p>{data.aiSearch.message}</p>
                        <StyledSearchResultsIFrame
                            src={`/car-search?nolayout=true&${data.aiSearch.searchUrl}`}
                            title="search-results"
                        />
                    </>
                )
            } else {
                return <p>{data?.aiSearch?.message ?? 'Sorry, something went wrong. Try another query'}</p>
            }
        }
        return null
    }
    return (
        <div>
            <GlobalStyle scrollBehaviour={true} />
            <StyledSearchResults>
                <StyledAiSearchMain>
                    <h1>
                        AI Search <StyledIconIntelligenceSpin title={'sparkles'} />
                    </h1>
                    <p>Tell us a bit about what you&apos;re looking for and we&apos;ll help you find your next car</p>
                    <StyledAiSearchQueryContainer>
                        <StyledQueryInput
                            id={'query-input'}
                            name={'query-input'}
                            fieldType={'text'}
                            label={''}
                            ref={inputRef}
                            onKeyUp={(e) => {
                                if (e.key == 'Enter') doSearch()
                            }}
                        />
                        <Button onClick={doSearch} text={'Search'} />
                    </StyledAiSearchQueryContainer>
                    {loading ? <Spinner /> : null}
                    {error ? <p>Sorry, something went wrong. Try another query</p> : null}
                    {results()}
                </StyledAiSearchMain>
            </StyledSearchResults>
        </div>
    )
}

export const AiSearchPageWithLayout = withLayout(AiSearchPage, {
    HeaderComponent: Header,
    FooterComponent: Footer,
    mainClassName: 'ai-search-page',
})
